var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.userIsAdmin
        ? _c(
            "v-card",
            [
              _c(
                "v-layout",
                {
                  staticStyle: { "margin-bottom": "25px" },
                  attrs: { wrap: "" },
                },
                [
                  _c(
                    "v-flex",
                    {
                      staticStyle: { margin: "24px 24px 0px 24px" },
                      attrs: { xs12: "" },
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          filled: "",
                          clearable: "",
                          "return-object": "",
                          items: _vm.fornitori,
                          "item-text": "nome",
                          label: "Fornitori",
                          hint: "Selezionare fornitore per visualizzare le statistiche",
                        },
                        model: {
                          value: _vm.fornitore,
                          callback: function ($$v) {
                            _vm.fornitore = $$v
                          },
                          expression: "fornitore",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.idFornitore
        ? _c(
            "v-card",
            [
              _c("v-card-title", [_vm._v(" STATISTICHE CAPI ")]),
              _c(
                "v-layout",
                {
                  staticStyle: { "margin-bottom": "50px" },
                  attrs: { wrap: "" },
                },
                [
                  _c(
                    "v-flex",
                    {
                      staticStyle: { margin: "0px 24px 24px 24px" },
                      attrs: { xs12: "" },
                    },
                    [
                      _c(
                        "v-tabs",
                        [
                          _c("v-tab", [_vm._v(" stagione ")]),
                          _c("v-tab", [_vm._v(" fase ")]),
                          _c("v-tab", [_vm._v(" consegna ")]),
                          _c("v-tab", [_vm._v(" lotto ")]),
                          _c(
                            "v-tab-item",
                            [_c("GruppoLavorazionePerStagioneTabella")],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [_c("GruppoLavorazionePerFaseTabella")],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [_c("GruppoLavorazionePerConsegnaTabella")],
                            1
                          ),
                          _c(
                            "v-tab-item",
                            [_c("GruppoLavorazionePerLottoTabella")],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }